// All 36 channels as [gateA, gateB] pairs
export const CHANNELS = [
  [1, 8], [2, 14], [3, 60], [4, 63], [5, 15], [6, 59], [7, 31], [9, 52],
  [10, 20], [10, 34], [10, 57], [11, 56], [12, 22], [13, 33], [16, 48],
  [17, 62], [18, 58], [19, 49], [20, 34], [20, 57], [21, 45], [23, 43],
  [24, 61], [25, 51], [26, 44], [27, 50], [28, 38], [29, 46], [30, 41],
  [32, 54], [34, 57], [35, 36], [37, 40], [39, 55], [42, 53], [47, 64]
];

// Channel names for display
export const CHANNEL_NAMES = {
  '1-8': 'Inspiration (Channel des Aufwachens)',
  '2-14': 'Schlüsselwerte',
  '3-60': 'Mutation',
  '4-63': 'Logische Vorbereitung',
  '5-15': 'Rhythmus',
  '6-59': 'Konflikt',
  '7-31': 'Der Führungskanal',
  '9-52': 'Fokus',
  '10-20': 'Liebe',
  '10-34': 'Forschung',
  '10-57': 'Zukunft',
  '11-56': 'Anerkennung',
  '12-22': 'Zirkulation',
  '13-33': 'Das Ohr',
  '16-48': 'Talent',
  '17-62': 'Tritt',
  '18-58': 'Kritik',
  '19-49': 'Synthesis',
  '20-34': 'Charisma',
  '20-57': 'Prüfung',
  '21-45': 'Bewahrung',
  '23-43': 'Die Struktur',
  '24-61': 'Öffnung',
  '25-51': 'Der Betreuer',
  '26-44': 'Kapitalismus',
  '27-50': 'Bewahrung',
  '28-38': 'Stamina',
  '29-46': 'Die Annäherung',
  '30-41': 'Erkennung',
  '32-54': 'Transformation',
  '35-36': 'Erkennung',
  '37-40': 'Gemeinschaft',
  '39-55': 'Empfänglichkeit',
  '34-57': 'Kraft / Der Archetyp',
  '42-53': 'Der Anfang',
  '47-64': 'Abstraktion'
};

// Get channel name with fallback
export function getChannelName(gateA, gateB) {
  const key1 = `${gateA}-${gateB}`;
  const key2 = `${gateB}-${gateA}`;
  return CHANNEL_NAMES[key1] || CHANNEL_NAMES[key2] || `Kanal ${gateA}→${gateB}`;
}

// Get all channels involving a specific gate
export function getChannelsForGate(gateNumber) {
  return CHANNELS.filter(([a, b]) => a === gateNumber || b === gateNumber);
}

// Check if a channel is defined (both gates defined)
export function isChannelDefined(gateA, gateB, definedGates) {
  return definedGates.includes(gateA) && definedGates.includes(gateB);
}

// Get all defined channels from a set of defined gates
export function getDefinedChannels(definedGates) {
  return CHANNELS.filter(([gateA, gateB]) =>
    definedGates.includes(gateA) && definedGates.includes(gateB)
  );
}

// Check if there is a motor-to-throat path
// Motor centers: root, sacral, solarplexus, ego
// Path means: connected through defined channels from motor to throat
export function hasMotorToThroatPath(definedChannels, definedCenters, gateToCenter) {
  const motorCenters = ['root', 'sacral', 'solarplexus', 'ego'];

  if (!definedCenters.some(g => motorCenters.includes(gateToCenter[g]))) {
    return false;
  }

  if (!definedCenters.some(g => gateToCenter[g] === 'throat')) {
    return false;
  }

  // Simple path check: for each defined channel, check if it connects motor to throat
  for (const [gateA, gateB] of definedChannels) {
    const centerA = gateToCenter[gateA];
    const centerB = gateToCenter[gateB];

    if ((motorCenters.includes(centerA) && centerB === 'throat') ||
        (motorCenters.includes(centerB) && centerA === 'throat')) {
      return true;
    }
  }

  return false;
}

// More sophisticated path finding using BFS
export function hasPathBetweenCenters(fromCenter, toCenter, definedGates, gateToCenter, channels) {
  const gatesInFromCenter = Object.entries(gateToCenter)
    .filter(([gate, center]) => center === fromCenter && definedGates.includes(parseInt(gate)))
    .map(([gate, _]) => parseInt(gate));

  const gatesInToCenter = Object.entries(gateToCenter)
    .filter(([gate, center]) => center === toCenter && definedGates.includes(parseInt(gate)))
    .map(([gate, _]) => parseInt(gate));

  if (gatesInFromCenter.length === 0 || gatesInToCenter.length === 0) {
    return false;
  }

  // BFS to find path
  const visited = new Set();
  const queue = gatesInFromCenter.slice();

  while (queue.length > 0) {
    const currentGate = queue.shift();

    if (gatesInToCenter.includes(currentGate)) {
      return true;
    }

    if (visited.has(currentGate)) {
      continue;
    }
    visited.add(currentGate);

    // Find all connected gates through defined channels
    const connectedChannels = channels.filter(([a, b]) =>
      (a === currentGate || b === currentGate) &&
      definedGates.includes(a) &&
      definedGates.includes(b)
    );

    for (const [gateA, gateB] of connectedChannels) {
      const nextGate = gateA === currentGate ? gateB : gateA;
      if (!visited.has(nextGate)) {
        queue.push(nextGate);
      }
    }
  }

  return false;
}
